import { makeStyles } from 'tss-react/mui';

interface AuthLayoutStyleParams {
  hasImage: boolean;
}

const useAuthLayoutStyles = makeStyles<AuthLayoutStyleParams>()((theme, { hasImage }) => ({
  root: {
    position: 'relative',
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  visualPanel: {
    position: 'relative',
    flexShrink: 0,
    width: 'min(100vh, 60vw)',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: hasImage
      ? {
          width: '100%',
          aspectRatio: '1 / 1',
        }
      : {
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
        },
  },
  visualImage: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  contentPanel: {
    position: 'relative',
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      zIndex: 1,
    },
  },
  footerSlot: {
    position: 'absolute',
    right: theme.spacing(2.5),
    bottom: theme.spacing(2.5),
  },
}));

export default useAuthLayoutStyles;
